export default __webpack_public_path__ + "static/media/icon.a33d6e7a.svg";